function loadScript(url) {
  return new Promise((resolve, reject) => {
    const head = document.head || document.getElementsByTagName("head")[0];
    const script = document.createElement("script");
    script.async = true;
    script.defer = true;
    script.id = "hs-script-loader";
    script.src = url;

    head.appendChild(script);

    script.onload = resolve;
    script.onerror = reject;
  });
}

async function install(Vue) {
  if (!import.meta.env.VUE_APP_HUBSPOT_ENABLED) return;

  window.hsConversationsSettings = {
    loadImmediately: false,
  };

  const hubspotPortalId = import.meta.env.VUE_APP_HUBSPOT_KEY;
  await loadScript(`//js.hs-scripts.com/${hubspotPortalId}.js`);
}
export default {
  install,
};
